@if (media.mediaType === MediaType.Image) {
	<div
		class="mediaCard"
		[class.active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		(click)="mediaClicked()"
	>
		<div class="mediaHeader">
			<mat-icon class="mediaIcon"> image </mat-icon>
			<img
				[src]="simUtilityService.getMediaPath(media, 180)"
				[title]="media.name"
				style="width: 100%; max-height: 100%; position: absolute"
				[alt]="media.fileName"
			/>
			<div class="controlsContainer">
				<button
					mat-mini-fab
					color="accent"
					class="mediaPlayButton"
					[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
				>
					<sim-animated-material-icon
						[trigger]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
						[endIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-stop',
							themeColor: 'accent',
						}"
						[startIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-play',
							themeColor: 'white',
						}"
					/>
				</button>
			</div>
		</div>
		<div class="mediaText">
			<div class="title">{{ media.name }}</div>
			<div class="description">{{ media.fileName }}</div>
		</div>
	</div>
}
